import React from 'react';
import { Props } from '.';
import CardIcon from '../../../../components/card-icon/CardIcon';
import Icon from '../../../../components/icon/Icon';
import { countExclusions } from '../../../../helpers/EventHelper';
import {
    CardTypeEnum,
    CoachRoleEnum,
    EventTypeEnum,
    EventVm,
    ExclusionTypeEnum,
} from '../../../../utils/api';

class MatchCoachLineupRow extends React.PureComponent<Props> {
    public render = (): React.ReactElement => {
        const { match, events, isHomeTeam, coach, initEvent, activeEvent } = this.props;

        const teamId = match ? (isHomeTeam ? match.homeTeamId : match.awayTeamId) : null;
        const commitedExclusions = countExclusions(events);

        let activeMatchCoachId: number | undefined;
        if (activeEvent) {
            const t = activeEvent.typeId as EventTypeEnum;
            if (t === EventTypeEnum.Card) {
                activeMatchCoachId =
                    activeEvent.card?.cardedCoachId ?? activeEvent.card?.cardedCoach?.id;
            } else if (t === EventTypeEnum.Exclusion) {
                activeMatchCoachId =
                    activeEvent.exclusion?.excludedCoachId ??
                    activeEvent.exclusion?.excludedCoach?.id;
            }
        }
        const isActiveCoach =
            activeMatchCoachId !== undefined && Number(activeMatchCoachId) === Number(coach.id);
        const activeType = isActiveCoach ? (activeEvent?.typeId as EventTypeEnum) : undefined;
        const editCardYellow =
            activeType === EventTypeEnum.Card && activeEvent?.card?.typeId === CardTypeEnum.Yellow;
        const editCardRed =
            activeType === EventTypeEnum.Card && activeEvent?.card?.typeId === CardTypeEnum.Red;
        const editExclusion = activeType === EventTypeEnum.Exclusion;

        const yellowCard = (
            <div
                key={1}
                onClick={
                    match
                        ? (): void =>
                              initEvent(EventTypeEnum.Card, {
                                  teamId: teamId,
                                  cardedCoachId: coach.id,
                                  typeId: CardTypeEnum.Yellow,
                              })
                        : undefined
                }
                className={`c-team__btn c-team__btn--yellow-card${
                    editCardYellow ? ' c-team__btn--editing' : ''
                }`}
                role="button"
            >
                <div className="c-team__btn-inner">
                    <span className="fake-svg">
                        <CardIcon type={CardTypeEnum.Yellow} />
                    </span>
                </div>
            </div>
        );

        const redCard = (
            <div
                key={2}
                onClick={
                    match
                        ? (): void =>
                              initEvent(EventTypeEnum.Card, {
                                  teamId: teamId,
                                  cardedCoachId: coach.id,
                                  typeId: CardTypeEnum.Red,
                              })
                        : undefined
                }
                className={`c-team__btn c-team__btn--red-card${
                    editCardRed ? ' c-team__btn--editing' : ''
                }`}
                role="button"
            >
                <div className="c-team__btn-inner">
                    <span className="fake-svg">
                        <CardIcon type={CardTypeEnum.Red} />
                    </span>
                </div>
            </div>
        );

        const exclusions = (
            <div
                key={3}
                onClick={
                    match
                        ? (): void =>
                              initEvent(EventTypeEnum.Exclusion, {
                                  teamId: teamId,
                                  excludedCoachId: coach.id,
                                  typeId: ExclusionTypeEnum.Penalty,
                              })
                        : undefined
                }
                className={`c-team__btn${editExclusion ? ' c-team__btn--editing' : ''}`}
                role="button"
            >
                <div className="c-team__btn-inner">
                    <Icon name="icon-times" />
                    <span>
                        &nbsp;
                        {commitedExclusions > 0 ? commitedExclusions : ''}
                    </span>
                </div>
            </div>
        );

        const coachCard = (
            <div
                key={4}
                onClick={
                    match
                        ? (): void =>
                              initEvent(EventTypeEnum.Exclusion, {
                                  teamId: teamId,
                                  excludedCoachId: coach.id,
                                  typeId: ExclusionTypeEnum.Penalty,
                              })
                        : undefined
                }
                className="c-team__btn"
                role="button"
            >
                <div className="c-team__btn-inner">
                    <span className="fake-svg">
                        {coach.roleId === CoachRoleEnum.Head_Coach ? 'HC' : 'AC'}
                    </span>
                </div>
            </div>
        );

        const render = [yellowCard, redCard, exclusions, coachCard];
        const yellowCardEvents = events.filter(
            (e: EventVm): boolean => e.card?.typeId === CardTypeEnum.Yellow
        );
        const redCardEvents = events.filter(
            (e: EventVm): boolean => e.card?.typeId === CardTypeEnum.Red
        );

        const rowMods: string[] = [];
        if (yellowCardEvents.length > 0) {
            rowMods.push('c-team__row--is-yellow-card-active');
        }
        if (redCardEvents.length > 0) {
            rowMods.push('c-team__row--is-red-card-active');
        }

        return (
            <div
                className={`c-team__row c-team__row--single c-team__row--${
                    isHomeTeam ? 'white' : 'blue'
                }-team c-team__row--coach-lineup ${rowMods.join(' ')}${
                    isActiveCoach ? ' c-team__row--active-event' : ''
                }`}
            >
                {render}
            </div>
        );
    };
}

export default MatchCoachLineupRow;
